( function () {
  
  let imageCarousels = document.querySelectorAll( '.carousel' );
  let carouselsObject = []
  imageCarousels.forEach( ( e ) => {
    carouselsObject.push(
      {
      "selector": e,
      "options": JSON.parse( atob( e.dataset.carouselConfig ) )
      }    
    )
  })  
  
  function createSplide( selector, options ) {    
    return new Splide( selector, options ).mount();
  }
  
  let createdCarousels = []  
  carouselsObject.forEach( ( e ) => {      
      createdCarousels.push( createSplide( e.selector, e.options ) )
  })
  
  if (Shopify.designMode) {
    document.addEventListener( 'shopify:section:load', (event) => {
      if ( event.target.classList.contains( 'carousel-section' ) ) {
        createdCarousels.forEach( ( t ) => {          
          t.refresh()
      })
      }
    })
  }  
})()